import { useState, useEffect } from 'react';

const slides = [
  {
    image: 'https://public.readdy.ai/ai/img_res/edited_24d2eb7e1e55df31b990314f66d6c00c_b2ffd9eb.jpg',
    eyebrow: 'PROFESSIONAL LANDSCAPING SINCE 2009',
    title: 'Transform Your Outdoor Space',
    subtitle: 'Expert landscape design and installation services that bring your vision to life with stunning results',
  },
  {
    image: 'https://public.readdy.ai/ai/img_res/021076639d1cb06a3eba604c607d3205.jpg',
    eyebrow: 'EFFICIENT IRRIGATION SOLUTIONS',
    title: 'Expert Irrigation Systems',
    subtitle: 'Keep your landscape thriving with our professional irrigation design, installation, and maintenance services',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=beautiful%20hardscape%20patio%20with%20stone%20pavers%20outdoor%20living%20space%20surrounded%20by%20lush%20landscaping%20and%20greenery%20professional%20landscape%20construction%20with%20clean%20simple%20background%20showing%20quality%20craftsmanship&width=1920&height=1080&seq=hero3&orientation=landscape',
    eyebrow: 'COMPLETE OUTDOOR SOLUTIONS',
    title: 'Landscape Design & Build',
    subtitle: 'From concept to completion, we create outdoor spaces that enhance your property and lifestyle',
  },
];

export default function HeroCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-black/20"></div>

          <div className="relative h-full max-w-7xl mx-auto px-6 flex items-center">
            <div className="max-w-2xl">
              <div className="text-emerald-400 text-sm font-semibold tracking-wider mb-4">
                {slide.eyebrow}
              </div>
              <h1 className="text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
                {slide.title}
              </h1>
              <p className="text-xl text-white/90 mb-8 leading-relaxed font-light">
                {slide.subtitle}
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="#portfolio"
                  className="px-8 py-4 bg-emerald-600 text-white rounded-full font-medium hover:bg-emerald-700 transition-all shadow-lg flex items-center space-x-2 whitespace-nowrap cursor-pointer"
                >
                  <span>View Our Work</span>
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a
                  href="#services"
                  className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-full font-medium hover:bg-white hover:text-emerald-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  Our Services
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}

      <button
        onClick={prevSlide}
        className="absolute left-6 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full text-white transition-all cursor-pointer"
      >
        <i className="ri-arrow-left-line text-xl"></i>
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-6 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full text-white transition-all cursor-pointer"
      >
        <i className="ri-arrow-right-line text-xl"></i>
      </button>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}
